import React from 'react';

import { Chip, Tooltip } from '@mui/material';

import useGetCapabilities from '~/hooks/apis/accommodation/useGetCapabilities';

interface Props {
  /** Flags the property is subscribed to, from the admin property response. */
  capabilities?: Array<string>;
}

/**
 * One chip per capability the property holds, labelled from the flag registry — a new flag needs
 * no change here, only its entry in svc-accommodation's `capabilityFlags.ts`.
 *
 * A flag missing from the registry is shown under its raw key rather than hidden: subscribing is
 * generic, so a flag can exist ahead of the entry describing it, and hiding it would make this
 * header disagree with the Feature Rollout tab.
 */
export default function AccommodationCapabilityChips({ capabilities }: Props) {
  const { data: registry } = useGetCapabilities();

  if (!capabilities?.length) {
    return null;
  }

  return (
    <>
      {capabilities.map((flag) => {
        const definition = registry?.find((entry) => entry.flag === flag);
        const label = definition?.label ?? flag;
        return (
          <Tooltip key={flag} title={definition?.description ?? `Capability \`${flag}\` is enabled.`}>
            <Chip label={label} size="small" color="success" variant="outlined" />
          </Tooltip>
        );
      })}
    </>
  );
}
